var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hv-notice",style:({
    color: _vm.data.color,
    background: _vm.data.background,
    'font-size':_vm.data.fontSize
  })},[_c('MarqueeTips',{attrs:{"content":_vm.data.title,"speed":30}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }